<template>
  <div>
    <Loading v-show="show" />

    <div id="nav">
      <header>
        <div class="header-top">
          <div class="container">
            <div class="row">
              <div class="col-lg-6 col-md-6 d-none d-lg-block d-md-block">
                <span id="welcom_header"></span>
              </div>
              <div class="col-lg-6 col-md-6 col-12">
                <div class="header-top-right">
                  <div class="content">
                    <router-link to="/" id="address_header"> </router-link>
                  </div>
                  <div class="content">
                    <router-link to="/" id="phone_header"> </router-link>
                  </div>
                  <div v-show="!showHide" class="content lang_div_med">
                    <a id="lang_btn" @click="lang('Ar')">  العربية</a>
                  </div>
                  <div v-show="showHide" class="content lang_div_med">
                    <a id="lang_btn" @click="lang('En')"> English</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="header-logo-menu sticker">
          <div class="container">
            <div class="row">
              <div class="col-lg-3 col-12">
                <div class="logo">
                  <router-link to="/">
                    <img v-bind:src="TopLogoUrl" alt="YemenGulf" />
                  </router-link>
                </div>
              </div>
              <div class="col-lg-9 col-12">
                <div class="mainmenu-area pull-left" style="text-align: left">
                  <div class="mainmenu d-none d-lg-block">
                    <nav>
                      <ul id="nav">
                        <li class="current">
                          <router-link to="/">{{ home }}</router-link>
                        </li>
                        <li>
                          <a href="javascript:void(0)">{{ aboutUs }} </a>
                          <ul class="sub-menu" style="width: 280px">
                            <li v-for="leader in Leader" :key="leader.postId">
                              <router-link
                                :to="{
                                  name: 'Leader-with-id-And-Type',
                                  params: {
                                    type: 'Univ.Home.Leader',
                                    id: leader.postID,
                                  },
                                }"
                              >
                                {{ leader.postTitle
                                }}<i :class="leader.icon1"></i
                              ></router-link>
                            </li>
                            <li
                              v-for="aboutdata in AboutData"
                              :key="aboutdata.postId"
                            >
                              <router-link
                                :to="{
                                  name: 'Page-with-id-And-Type',
                                  params: {
                                    type: 'Univ.Home.AboutMenue',
                                    id: aboutdata.postID,
                                  },
                                }"
                              >
                                {{ aboutdata.postTitle
                                }}<i :class="aboutdata.icon1"></i
                              ></router-link>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <a href="javascript:void(0)">{{ colege }}</a>
                          <ul class="sub-menu" style="width: 288px">
                            <li v-for="faculty in Faculty" :key="faculty.BrnId">
                              <router-link
                                :to="{
                                  name: 'Faculties-with-id',
                                  params: {
                                    id: faculty.BrnId,
                                  },
                                }"
                              >
                                {{ faculty.Faculty }}
                              </router-link>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <a href="javascript:void(0)">{{ cnter }}</a>

                          <ul class="sub-menu" style="width: 280px">
                            <li
                              v-for="centerdata in CenterData"
                              :key="centerdata.postId"
                            >
                              <router-link
                                :to="{
                                  name: 'Page-with-id-And-Type',
                                  params: {
                                    type: 'Univ.Q.Center',
                                    id: centerdata.postID,
                                  },
                                }"
                              >
                                {{ centerdata.postTitle
                                }}<i :class="centerdata.icon1"></i
                              ></router-link>
                            </li>
                          </ul>
                        </li>

                        <!-- service -->
                        <li>
                          <a href="javascript:void(0)">{{ Service }} </a>
                          <ul class="sub-menu" style="width: 288px">
                            <li
                              v-for="service in ServiceData"
                              :key="service.postID"
                            >
                              <router-link
                                :to="{
                                  name: 'Service',
                                  params: {
                                    id: service.postID,
                                  },
                                }"
                              >
                                {{ service.postTitle }}
                              </router-link>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <a href="javascript:void(0)">{{ banshes }}</a>
                          <ul class="sub-menu" style="width: 288px">
                            <li v-for="bransh in Bransh" :key="bransh.BrnId">
                              <router-link
                                :to="{
                                  name: 'Branshes-with-id',
                                  params: {
                                    id: bransh.BrnId,
                                  },
                                }"
                              >
                                {{ bransh.Bransh }}
                              </router-link>
                            </li>
                          </ul>
                        </li>
                        <li style="margin-left: 24px">
                          <router-link to="/ContactUs"
                            >{{ contact2 }}
                          </router-link>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Mobile Menu Area start -->
        <div class="mobile-menu-area">
          <div class="container clearfix">
            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="mobile-menu">
                  <nav id="dropdown" style="display:none">
                    <ul dir="rtl">
                      <li class="current">
                        <router-link to="/">{{ home }}</router-link>
                      </li>

                      <li>
                        <a href="javascript:void(0)">{{ aboutUs }} </a>
                        <ul class="sub-menu" style="width: 280px">
                          <li v-for="leader in Leader" :key="leader.postId">
                            <router-link
                              :to="{
                                name: 'Leader-with-id-And-Type',
                                params: {
                                  type: 'Univ.Home.Leader',
                                  id: leader.postID,
                                },
                              }"
                            >
                              {{ leader.postTitle }}<i :class="leader.icon1"></i
                            ></router-link>
                          </li>

                          <li
                            v-for="aboutdata in AboutData"
                            :key="aboutdata.postId"
                          >
                            <router-link
                              :to="{
                                name: 'Page-with-id-And-Type',
                                params: {
                                  type: 'Univ.Home.AboutMenue',
                                  id: aboutdata.postID,
                                },
                              }"
                            >
                              {{ aboutdata.postTitle
                              }}<i :class="aboutdata.icon1"></i
                            ></router-link>
                          </li>
                        </ul>
                      </li>   
                      <li>
                        <a href="javascript:void(0)">{{ colege }}</a>
                        <ul class="sub-menu">
                          <li v-for="faculty in Faculty" :key="faculty.BrnId">
                            <router-link
                              :to="{
                                name: 'Faculties-with-id',
                                params: {
                                  id: faculty.BrnId,
                                },
                              }"
                            >
                              {{ faculty.Faculty }}
                            </router-link>
                          </li>
                        </ul>
                      </li>

                      <li>
                        <a href="javascript:void(0)">{{ cnter }}</a>

                        <ul class="sub-menu">
                          <li
                            v-for="centerdata in CenterData"
                            :key="centerdata.postId"
                          >
                            <router-link
                              :to="{
                                name: 'Page-with-id-And-Type',
                                params: {
                                  type: 'Univ.Q.Center',
                                  id: centerdata.postID,
                                },
                              }"
                            >
                              {{ centerdata.postTitle }}
                              </router-link
                            >
                          </li>
                        </ul>
                      </li>
                      <!-- service -->
                      <li>
                        <a href="javascript:void(0)">{{ Service }} </a>
                        <ul class="sub-menu">
                          <li
                            v-for="service in ServiceData"
                            :key="service.postID"
                          >
                            <router-link
                              :to="{
                                name: 'Service',
                                params: {
                                  id: service.postID,
                                },
                              }"
                            >
                              {{ service.postTitle }}
                            </router-link>
                          </li>
                        </ul>
                      </li>
                      <!-- end service -->
                      <li>
                        <a href="javascript:void(0)">{{ banshes }}</a>
                        <ul class="sub-menu" style="width: 288px">
                          <li v-for="bransh in Bransh" :key="bransh.BrnId">
                            <router-link
                              :to="{
                                name: 'Branshes-with-id',
                                params: {
                                  id: bransh.BrnId,
                                },
                              }"
                            >
                              {{ bransh.Bransh }}
                            </router-link>
                          </li>
                        </ul>
                      </li>

                      <li>
                        <router-link to="/ContactUs">
                          {{ contact2 }}</router-link
                        >
                        <ul class="sub-menu">
                          <li>
                            <router-link to="/ContactUs"
                              > {{location_}}</router-link
                            >
                          </li>
                          <li>
                            <router-link to="/ContactUs"
                              >{{ ContactNum }} </router-link
                            >
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <router-view :key="$route.fullPath"></router-view>

      <div class="newsletter-area newsletter-area_2 newsletter-area_3">
        <div class="container">
          <div class="row rowFooter">
            <div class="col-lg-5 col-md-5">
              <div class="newsletter-content newsletter-content-footer">
                <h3 id="postTitleFooter"></h3>
                <h2 id="postSubTitleFooter"></h2>
              </div>
            </div>
            <div class="col-lg-7 col-md-7">
              <div class="newsletter-form angle d-none">
                <form
                  action="#"
                  id="mc-form"
                  class="mc-form footer-newsletter fix"
                >
                  <div class="subscribe-form">
                    <input
                      id="mc-email "
                      type="email "
                      name="email "
                      placeholder="ادخل البريد الالكترونى"
                    />
                    <button id="mc-submit " type="submit">الإشتراك</button>
                  </div>
                </form>
                <div class="mailchimp-alerts text-centre fix pull-left">
                  <div class="mailchimp-submitting"></div>
                  <div class="mailchimp-success"></div>
                  <div class="mailchimp-error"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-widget-area">
        <div class="container">
          <div class="row">
            <div class="col-lg-3 col-md-6">
              <div class="single-footer-widget">
                <div class="footer-logo">
                  <router-link to="/">
                    <img v-bind:src="bottomLogoUrl" alt=" "
                  /></router-link>
                </div>
                <p id="postDetails"></p>
                <div class="social-icons">
                  <a id="facebook_footer" target="_blank"
                    ><img src="/img/facebook.svg" alt="" />
                  </a>
                  <a id="instgram_footer" target="_blank"
                    ><img src="/img/instagram.svg" alt=""
                  /></a>
                  <a id="twitter_footer" target="_blank"
                    ><img src="/img/twitter.svg" alt=""
                  /></a>
                  <a id="youtube_footer" target="_blank"
                    ><img src="/img/youtube.svg" alt=""
                  /></a>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="single-footer-widget">
                <h3>{{ contct }}</h3>
                <a id="f11_footer" ></a>
                <a id="f21_footer"></a>
                <a id="f31_footer"></a>
                <a id="f41_footer"></a>
                <a target="_blank" href="https://yg-u.net/" id="f51_footer"></a>
                <span id="f61_footer"></span>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="single-footer-widget">
                <h3>{{ browseMore }}</h3>
                <ul class="footer-list">
                  <li>
                    <router-link to="/">{{ home }}</router-link>
                  </li>

                  <li v-for="leader in Leader" :key="leader.postId">
                    <router-link
                      :to="{
                        name: 'Leader-with-id-And-Type',
                        params: {
                          type: 'Univ.Home.Leader',
                          id: leader.postID,
                        },
                      }"
                    >
                      {{ leader.postTitle }}</router-link
                    >
                  </li>

                  <li v-for="aboutdata in AboutData" :key="aboutdata.postId">
                    <router-link
                      :to="{
                        name: 'Page-with-id-And-Type',
                        params: {
                          type: 'Univ.Home.AboutMenue',
                          id: aboutdata.postID,
                        },
                      }"
                    >
                      {{ aboutdata.postTitle }}</router-link
                    >
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="single-footer-widget">
                <h3></h3>
                <div class="instagram-image">
                  <div
                    v-for="gellery in Gellery"
                    :key="gellery.postId"
                    class="footer-img"
                  >
                    <a
                      :href="
                        'https://api2.yg-u.net:444/images/post/' +
                        gellery.postImage
                      "
                      target="_blank"
                    >
                      <img
                        v-bind:src="
                          'https://api2.yg-u.net:444/images/post/' +
                          gellery.postImage
                        "
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer class="footer-area">
        <div class="container">
          <div class="row flex_direction">
            <div class="col-lg-6 col-md-7 col-12">
              <span style="float:right;direction:rtl"
                  >&copy;{{ currentYear }} كافة الحقوق محفوظة <a
                    class="link_newtouch"
                    href="http://newtouch.dev/"
                    target="_blank"
                  >نيوتاتش للحلول التقنية الذكية</a>
                </span>
            </div>
            <div class="col-lg-6 col-md-5 col-12">
              <div class="column-right">
                <span style="float:left;direction:ltr"
                  >&copy;{{ currentYear }} All rights reserved<a
                    class="link_newtouch"
                    href="http://newtouch.dev/"
                    target="_blank"
                  >
                    NewTouch
                  Smart Technology Solutions</a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import Loading from "./components/Loading";
import axios from "axios";
import ArJson from "../public/i18n/Ar.json";
import EnJson from "../public/i18n/En.json";

export default {
  components: {
    Loading,
  },
  data() {
    return {
      show: true,
      showHide: true,
      TopLogoUrl: "",
      bottomLogoUrl: "",
      currentYear: new Date().getFullYear(),
      FooterData: [],
      AboutData: [],
      Leader: [],
      CenterData: [],
      Gellery: [],
      Faculty: [],
      ServiceData: [],
      Bransh: [],
      ArTranslat: ArJson,
      EnTranslat: EnJson,
      translate: "",
      home: "",
      aboutUs: "",
      cnter: "",
      colege: "",
      banshes: "",
      portal: "",
      contct: "",
      language: "",
      browseMore: "",
      copyRight: "",
      location_: "",
      ContactNum: "",

      Management: "",
      Service: "",
      contact2: "",
    };
  },
  mounted() {
    var self = this;
    if (localStorage.getItem("lang") == null) {
      axios({
        method: "get",
        url: "https://api2.yg-u.net:444/languages/getLangIsMain",
      })
        .then(function (response) {
          self.lang = response.data[0]["LangId"];
          localStorage.setItem("lang", response.data[0]["LangId"]);
          if (response.data[0]["LangId"] == "Ar") {
            self.translate = self.ArTranslat;
            document.getElementById("langfilewebsites")?.remove();
            self.getApis();
            self.showHide=true;
          } else {
            self.translate = self.EnTranslat;
            let link1 = document.createElement("link");
            link1.setAttribute("rel", "stylesheet");
            link1.id = "langfilewebsites";
            link1.setAttribute("href", "./style-ltr.css");
            document.head.appendChild(link1);
            self.getApis();
            self.showHide=false;
          }
        })
        .catch(function (response) {
          // eslint-disable-next-line no-console
          console.log("error", response);
        });
    } else {
      //translate
      if (localStorage.getItem("lang") == "Ar") {
        self.translate = self.ArTranslat;
        document.getElementById("langfilewebsites")?.remove();
        self.getApis();
        self.showHide=true;
      } else {
        self.showHide=false;
        self.translate = self.EnTranslat;
        let link1 = document.createElement("link");
        link1.setAttribute("rel", "stylesheet");
        link1.id = "langfilewebsites";
        link1.setAttribute("href", "./style-ltr.css");
        document.head.appendChild(link1);
        self.getApis();
      }
    }
  },
  methods: {
    lang(lang) {
      localStorage.setItem("lang", lang);
      location.replace('/');
      console.log("main")
    },
    getApis() {
      var self = this;
      self.home = self.translate[0]["HeaderAndFooter"]["Home"];
      self.aboutUs = self.translate[0]["HeaderAndFooter"]["about"];
      self.colege = self.translate[0]["HeaderAndFooter"]["college"];
      self.cnter = self.translate[0]["HeaderAndFooter"]["centers"];
      self.portal = self.translate[0]["HeaderAndFooter"]["studentPortal"];
      self.contct = self.translate[0]["HeaderAndFooter"]["contact"];
      self.language = self.translate[0]["HeaderAndFooter"]["Languages"];
      self.browseMore = self.translate[0]["HeaderAndFooter"]["browseMore"];
      self.copyRight = self.translate[0]["HeaderAndFooter"]["copyRight"];
      self.contact2 = self.translate[0]["HeaderAndFooter"]["contact2"];
      self.Service = self.translate[0]["HeaderAndFooter"]["Service"];
      self.Management = self.translate[0]["HeaderAndFooter"]["Management"];
      self.banshes = self.translate[0]["HeaderAndFooter"]["banshes"];
      self.location_ = self.translate[0]["contactUs"]["location"];
      self.ContactNum = self.translate[0]["contactUs"]["ContactNum"];

      var bodyFormData = new FormData();
      bodyFormData.append("check", "getPost");
      bodyFormData.append("Lang", localStorage.getItem("lang"));
      bodyFormData.append("FbrnId", "");
      bodyFormData.append("Type", "Univ.Header.Data");
      bodyFormData.append("ParentId", "NTROOT0");
      bodyFormData.append("PostName", "");
      bodyFormData.append("Pno", "1");
      axios({
        method: "post",
        url: "https://api2.yg-u.net:444/our_team/getPost",
        data: bodyFormData,
      }).then(function (response) {
        var arr = response.data;
        if (arr.length != 0) {
          self.TopLogoUrl =
            "https://api2.yg-u.net:444/images/post/" +
            response.data[0]["postImage"];
          document.getElementById("welcom_header").innerHTML =
            '<i class="fa fa-balance-scale"style="padding-left: 7px; font-size: 16px"></i>' +
            response.data[0]["f1"];
          document.getElementById("address_header").innerHTML =
            '<i class="fa  fa-map-marker"></i>' + response.data[0]["f2"];
          document.getElementById("phone_header").innerHTML =
            '<i class="fa fa-phone"></i>' + response.data[0]["f3"];
        }
      });
      var bodyFormFooterData = new FormData();
      bodyFormFooterData.append("check", "getPostDetails");
      bodyFormFooterData.append("Lang", localStorage.getItem("lang"));
      bodyFormFooterData.append("FbrnId", "");
      bodyFormFooterData.append("Type", "Univ.Footer.Data");
      bodyFormFooterData.append("ParentId", "NTROOT0");
      bodyFormFooterData.append("PostName", "");
      bodyFormFooterData.append("Pno", "1");
      axios({
        method: "post",
        url: "https://api2.yg-u.net:444/our_team/getPost",
        data: bodyFormFooterData,
      })
        .then(function (response) {
          self.FooterData = response.data;
          if (self.FooterData.length != 0) {
            self.bottomLogoUrl =
              "https://api2.yg-u.net:444/images/post/" +
              self.FooterData[0]["postImage"];

            document
              .getElementById("facebook_footer")
              .setAttribute("href", response.data[0]["facebook1"]);

            document
              .getElementById("facebook_footer")
              .setAttribute("href", response.data[0]["facebook1"]);
            document
              .getElementById("instgram_footer")
              .setAttribute("href", response.data[0]["instgram1"]);
            document
              .getElementById("twitter_footer")
              .setAttribute("href", response.data[0]["tweeter1"]);
            document
              .getElementById("youtube_footer")
              .setAttribute("href", response.data[0]["youtube1"]);

            document.getElementById("postTitleFooter").innerText =
              response.data[0]["postTitle"];
            document.getElementById("postSubTitleFooter").innerText =
              response.data[0]["postSubTitle"];
            document.getElementById("f11_footer").innerHTML =
              '<i class="fa fa-phone"></i>' + response.data[0]["f11"];
            document.getElementById("f21_footer").innerHTML =
              '<i class="fa fa-phone"></i>' + response.data[0]["f21"];
            // document.getElementById("f21_footer").setAttribute('href','tel:'+response.data[0]["f21"]);
            document.getElementById("f31_footer").innerHTML =
              '<i class="fa fa-phone"></i>' + response.data[0]["f31"];
              // document.getElementById("f31_footer").setAttribute('href','tel:'+response.data[0]["f31"]);
            document.getElementById("f41_footer").innerHTML =
              '<i class="fa fa-envelope"></i>' + response.data[0]["f41"];
              document.getElementById("f41_footer").setAttribute('href','mailTo:'+response.data[0]["f41"]);
            document.getElementById("f51_footer").innerHTML =
              '<i class="fa fa-globe"></i>' + response.data[0]["f51"];
            document.getElementById("f61_footer").innerHTML =
              '<i class="fa fa-map-marker"></i>' + response.data[0]["f61"];

            document.getElementById("postDetails").innerHTML =
              self.FooterData[0]["postDetails"];
          }
        })
        .catch(function (response) {
          // eslint-disable-next-line no-console
          console.log("error", response);
        });
      var bodyFormAboutMenueData = new FormData();
      bodyFormAboutMenueData.append("check", "getPost");
      bodyFormAboutMenueData.append("Lang", localStorage.getItem("lang"));
      bodyFormAboutMenueData.append("FbrnId", "");
      bodyFormAboutMenueData.append("Type", "Univ.Home.AboutMenue");
      bodyFormAboutMenueData.append("ParentId", "NTROOT0");
      bodyFormAboutMenueData.append("PostName", "");
      bodyFormAboutMenueData.append("Pno", "5");
      axios({
        method: "post",
        url: "https://api2.yg-u.net:444/our_team/getPost",
        data: bodyFormAboutMenueData,
      })
        .then(function (response) {
          self.AboutData = response.data;
        })
        .catch(function (response) {
          // eslint-disable-next-line no-console
          console.log("error", response);
        });
      var bodyFormLeaderData = new FormData();
      bodyFormLeaderData.append("check", "getPost");
      bodyFormLeaderData.append("Lang", localStorage.getItem("lang"));
      bodyFormLeaderData.append("FbrnId", "");
      bodyFormLeaderData.append("Type", "Univ.Home.Leader");
      bodyFormLeaderData.append("ParentId", "NTROOT0");
      bodyFormLeaderData.append("PostName", "");
      bodyFormLeaderData.append("Pno", "6");
      axios({
        method: "post",
        url: "https://api2.yg-u.net:444/our_team/getPost",
        data: bodyFormLeaderData,
      })
        .then(function (response) {
          self.Leader = response.data;
        })
        .catch(function (response) {
          // eslint-disable-next-line no-console
          console.log("error", response);
        });
      var bodyFormCenterData = new FormData();
      bodyFormCenterData.append("check", "getPost");
      bodyFormCenterData.append("Lang", localStorage.getItem("lang"));
      bodyFormCenterData.append("FbrnId", "");
      bodyFormCenterData.append("Type", "Univ.Q.Center");
      bodyFormCenterData.append("ParentId", "NTROOT0");
      bodyFormCenterData.append("PostName", "");
      bodyFormCenterData.append("Pno", "10");
      axios({
        method: "post",
        url: "https://api2.yg-u.net:444/our_team/getPost",
        data: bodyFormCenterData,
      })
        .then(function (response) {
          self.CenterData = response.data;
        })
        .catch(function (response) {
          // eslint-disable-next-line no-console
          console.log("error", response);
        });
      // service
      var bodyFormServicesData = new FormData();
      bodyFormServicesData.append("check", "getPost");
      bodyFormServicesData.append("Lang", localStorage.getItem("lang"));
      bodyFormServicesData.append("FbrnId", "");
      bodyFormServicesData.append("Type", "Univ.Services");
      bodyFormServicesData.append("ParentId", "NTROOT0");
      bodyFormServicesData.append("PostName", "");
      bodyFormServicesData.append("Pno", "10");
      axios({
        method: "post",
        url: "https://api2.yg-u.net:444/our_team/getPost",
        data: bodyFormServicesData,
      })
        .then(function (response) {
          self.ServiceData = response.data;
          //end service
        })
        .catch(function (response) {
          // eslint-disable-next-line no-console
          console.log("error", response);
        });
        bodyFormData = new FormData();
      bodyFormData.append("check", "");
      bodyFormData.append("Lang", localStorage.getItem("lang"));
      bodyFormData.append("FbrnId", "U");
      axios({
        method: "post",
        url: "https://api2.yg-u.net:444/our_team/getMainSys",
        data: bodyFormData,
      })
        .then(function (response) {
          response.data.mainBrn.forEach((element) => {
            if (element.brnSys == "Univ.Faculty") {
              self.Faculty.push({
                BrnId: element.brnId,
                Faculty: element.brnName,
              });
            } 

          });
        })
        .catch(function (response) {
          // eslint-disable-next-line no-console
          console.log("error", response);
        });
        bodyFormData = new FormData();
      bodyFormData.append("check", "");
      bodyFormData.append("Lang", localStorage.getItem("lang"));
      bodyFormData.append("FbrnId", "U");
      axios({
        method: "post",
        url: "https://api2.yg-u.net:444/our_team/getMainSys",
        data: bodyFormData,
      })
        .then(function (response) {
          response.data.mainBrn.forEach((element) => {
           if (element.brnSys == "Univ.Branshes") {
              self.Bransh.push({
                BrnId: element.brnId,
                Bransh: element.brnName,
              });
            }
          });
        })
        .catch(function (response) {
          // eslint-disable-next-line no-console
          console.log("error", response);
        });
      var bodyFormGelleryData = new FormData();
      bodyFormGelleryData.append("check", "getPost");
      bodyFormGelleryData.append("Lang", localStorage.getItem("lang"));
      bodyFormGelleryData.append("FbrnId", "");
      bodyFormGelleryData.append("Type", "Univ.Gellery");
      bodyFormGelleryData.append("ParentId", "NTROOT0");
      bodyFormGelleryData.append("PostName", "");
      bodyFormGelleryData.append("Pno", "6");
      axios({
        method: "post",
        url: "https://api2.yg-u.net:444/our_team/getPost",
        data: bodyFormGelleryData,
      })
        .then(function (response) {
          self.Gellery = response.data;
          setTimeout(() => {
              self.show = false;
              document.getElementById('YG_U').setAttribute('style','display:none !important')
            }, 100);
        })
        .catch(function (response) {
          // eslint-disable-next-line no-console
          console.log("error", response);
        });
   
    },
  },
};
</script>
<style scoped>
.lang_btn {
  cursor: pointer !important;
}
.font_color {
  color: #3498db;
}
.link_newtouch {
  color: #3498db;
  font-weight: bold;
}
li i {
  color: #3498db;
}
li a {
  font-weight: bold;
}
.footer-img {
  width: 80px;
  height: 80px;
}
.mean-container .mean-nav ul li a {
  background: #f8f8f8;
  color: #666;
  display: block;
  float: left;
  font-size: 12px;
  margin: 0;
  padding: 1em 5%;
  text-align: right;
  text-decoration: none;
  text-transform: uppercase;
  width: 90%;
  font-weight: 700;
}
.mean-container .mean-nav ul li a.mean-expand {
  width: 26px;
  height: 15px;
  margin-top: 1px;
  padding: 12px !important;
  text-align: center;
  position: absolute;
  left: 0 !important;
  top: 0;
  z-index: 2;
  font-weight: 700;
  border: 0 !important;
  background: #f8f8f8;
}
#postTitleFooter,
#postSubTitleFooter {
  color: #000;
}
</style>
